// removed by extract-text-webpack-plugin
module.exports = {"question_wrapperx":"_3uIWR","question_wrapper":"_1XYNi","question":"_2HxCu","alternatives_label":"_1joes","alternative":"_2fEC_","alternative_selected":"_16isn _2fEC_","presentation":"RIW9i","presentation_label":"_10R1Y","agree":"BPq7k","button":"bnrZd","agreecomma":"Wby0J","description":"HPt0p","commentAfter":"_2a_nt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/InfoQuiz/Question.scss
 ** module id = 456
 ** module chunks = 0
 **/